import { render, staticRenderFns } from "./biometry-register.vue?vue&type=template&id=361d9e19&"
import script from "./biometry-register.vue?vue&type=script&lang=js&"
export * from "./biometry-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports